<template>
  <div class="h-full">
    <div class="h-full">
      <!-- <dv-charts class="right" :option="option" /> -->
      <div id="illnessBarChart" style="width: 100%; height: 500px"></div>
    </div>
    <DialogUserTable
      :show.sync="visible"
      :tableData="list"
      @onSelect="onCheckoutItemOfUser"
      :title="title"
      showTitle
    ></DialogUserTable>
    <DialogArchivesCard
      :id="checkUsers.sn"
      :show.sync="visibleArchives"
      @back="visible = true"
    ></DialogArchivesCard>
    <!-- </dv-border-box-13> -->
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapGetters } from "vuex";
import DialogUserTable from "./DialogUserTable.vue";
import DialogArchivesCard from "./DialogArchivesCard.vue";
export default {
  name: "LeftChart3",
  data() {
    return {
      visible: false,
      list: [],
      filterList: [],
      visibleArchives: false,
      checkUsers: {},
    };
  },
  components: {
    DialogUserTable,
    DialogArchivesCard,
  },
  computed: {
    ...mapGetters(["globalData"]),
  },
  watch: {
    globalData: {
      // handler(n, o) {
      //   this.$nextTick(() => {
      //     // this.list = this.globalData["users"] || [];
      //     this.initChart();
      //   });
      // },
    },
  },
  methods: {
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      // this.getArchivesDetail();
      this.visible = false;
      this.visibleArchives = true;
      return;
    },
    initChart() {
      // 绘制左侧面
      const CubeLeft = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function (ctx, shape) {
          // 会canvas的应该都能看得懂，shape是从custom传入的
          const xAxisPoint = shape.xAxisPoint;
          const c0 = [shape.x, shape.y];
          const c1 = [shape.x - 13, shape.y - 13];
          const c2 = [xAxisPoint[0] - 13, xAxisPoint[1] - 13];
          const c3 = [xAxisPoint[0], xAxisPoint[1]];
          ctx
            .moveTo(c0[0], c0[1])
            .lineTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .closePath();
        },
      });
      // 绘制右侧面
      const CubeRight = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c1 = [shape.x, shape.y];
          const c2 = [xAxisPoint[0], xAxisPoint[1]];
          const c3 = [xAxisPoint[0] + 18, xAxisPoint[1] - 9];
          const c4 = [shape.x + 18, shape.y - 9];
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath();
        },
      });
      // 绘制顶面
      const CubeTop = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function (ctx, shape) {
          const c1 = [shape.x, shape.y];
          const c2 = [shape.x + 18, shape.y - 9];
          const c3 = [shape.x + 5, shape.y - 22];
          const c4 = [shape.x - 13, shape.y - 13];
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath();
        },
      });
      // 注册三个面图形
      echarts.graphic.registerShape("CubeLeft", CubeLeft);
      echarts.graphic.registerShape("CubeRight", CubeRight);
      echarts.graphic.registerShape("CubeTop", CubeTop);

      const MAX = [];
      const VALUE = this.globalData["diseases"].map((v) => v.total).slice(0, 7);
      console.log("VALUE", VALUE);
      let option = {
        backgroundColor: "",
        title: {
          left: "left",
          show: true, //是否显示标题组件
          text: "居民主要疾病",
          textStyle: {
            color: this.$color.textColor,
            fontSize: "16px",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            var tar = params[0];
            return `${tar.name}<br/>患病率：${tar.value}%`;
          },
        },

        grid: {
          // left: 40,
          // right: 40,
          // bottom: 100,
          // top: 100,
          // containLabel: true,
          top: 40,
          left: 10,
        },
        xAxis: {
          type: "category",
          data: this.globalData["diseases"].map((v) => v.name).slice(0, 7),
          axisLine: {
            lineStyle: {
              show: true,
              color: "#FFFFFF",
            },
            show: false,
          },
          axisLabel: {
            margin: 10,
            color: this.$color.textColor,
            textStyle: {
              fontSize: 11,
            },
            interval: 0,
            rotate: -30,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#ccc",
            },
          },

          splitLine: {
            show: true,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            fontSize: 16,
            color: "#9FACBC",
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#333B55",
              type: "dashed",
            },
          },
        },
        series: [
          {
            type: "custom",
            renderItem: function (params, api) {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: "group",
                children: [
                  {
                    type: "CubeLeft",
                    shape: {
                      api,
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: "rgba(46, 85, 151,.2)",
                      // fill: "rgba(246,225,182,.2)",
                    },
                  },
                  {
                    type: "CubeRight",
                    shape: {
                      api,
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: "rgba(46, 85, 151,.2)",
                      // fill: "rgba(246,225,182,.2)",
                    },
                  },
                  {
                    type: "CubeTop",
                    shape: {
                      api,
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: "rgba(46, 85, 151,.2)",
                      // fill: "rgba(246,225,182,.2)",
                    },
                  },
                ],
              };
            },
            data: MAX,
          },
          {
            type: "custom",
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              var color1 =
                api.value(1) > 2000
                  ? "red"
                  : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: `rgba(${this.$color.colorRgb}, .5)`,
                        // color: "rgba(176, 96, 54, 1)",
                      },
                      {
                        offset: 1,
                        color: `rgba(${this.$color.colorRgb})`,
                      },
                    ]);
              var color2 =
                api.value(1) > 2000
                  ? "red"
                  : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        // color: "rgba(24,144,255,1)",
                        color: `rgba(${this.$color.colorRgb}, .5)`,
                      },
                      {
                        offset: 1,
                        // color: "rgba(64,169,255,1)",
                        color: `rgba(${this.$color.colorRgb}, .5)`,
                      },
                    ]);
              return {
                type: "group",
                children: [
                  {
                    type: "CubeLeft",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: color1,
                    },
                  },
                  {
                    type: "CubeRight",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: color1,
                    },
                  },
                  {
                    type: "CubeTop",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: color2,
                    },
                  },
                ],
              };
            },
            data: VALUE,
          },
          {
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "top",

                fontSize: 16,
                color: "#fff",
                offset: [2, -25],
              },
            },
            itemStyle: {
              color: "transparent",
            },
            tooltip: {},
            data: MAX,
          },
        ],
      };
      this.$nextTick(() => {
        var myChart = echarts.init(document.getElementById("illnessBarChart"));

        myChart.setOption(option);
        myChart.off("click");
        // myChart.on("click", (params) => {
        //   console.log(params);
        //   this.title = params.name;
        //   let list = this.globalData["diseases"].find(
        //     (v) => v.name == params.name
        //   );
        //   this.list = list.users;
        //   this.visible = true;
        // });
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.left-chart-3 {
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  background: #fff;
  overflow: hidden;
  height: 440px;
  .lc3-header {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    text-indent: 20px;
    margin-top: 10px;
  }

  .lc3-details {
    height: 40px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: @primary-color;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc3-chart {
    flex: 1;
  }
}
</style>
